<template>
    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M220.001-130.001v-649.998h311.46l18.23 84.462h230.308v338.074H553.616l-18.138-83.846H265.385v311.308h-45.384ZM500-568.923Zm92.692 166.077h141.923v-247.308h-224l-18.23-84.461h-227v247.923h309.076l18.231 83.846Z"/></svg>
</template>
